import { AnimatedIntro, CustomBottomBar } from '@components';
import { Button, causeriesWelcome, Container, CustomIcon, Typography } from '@design-system';
import React from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

export const CauseriesPage: React.FC = () => {
    const navigate = useNavigate();
    const steps = ['Découvrez les instructions', 'Répondez au quizz', "Signez l'émargement", 'La thématique est validée'];

    return (
        <Container className="causeries-page" height="fill">
            <Container bordered="grey" center column padding="large" height="fill">
                <CustomIcon src={causeriesWelcome} alt="Causeries" />
                <Typography intrinsic="h1">Bienvenue</Typography>
                <Typography intrinsic="h3" defaultSpacing>
                    sur la section causerie
                </Typography>

                {/* <Typography intrinsic="p" color="marine" className="mt-small-spacing">
                    Le module qui facilite la compréhension et la validation des causeries de sécurité.
                </Typography>
                <Typography intrinsic="p" variant="secondary" color="marine" className="mt-medium-spacing">
                    Par thématique, veuillez suivre les étapes pour valider vos connaissances :{' '}
                </Typography> */}

                <AnimatedIntro steps={steps} />
            </Container>

            <CustomBottomBar>
                <Button
                    color="marine"
                    size="fullwidth"
                    icon={<MdKeyboardArrowRight />}
                    iconPosition="forced-right"
                    iconColor="white"
                    iconSize={30}
                    onClick={() => {
                        navigate('/sante-securite/causeries/list');
                    }}
                >
                    <Typography intrinsic="p">Commencer</Typography>
                </Button>
            </CustomBottomBar>
        </Container>
    );
};
